var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7825_14490)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0C6.72656 0 0 6.72656 0 15C0 23.2734 6.72656 30 15 30C23.2734 30 30 23.2734 30 15C30 6.72656 23.2734 0 15 0Z",
    fill: "#4BAE4F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2539 9.94287C22.6172 10.3062 22.6172 10.9038 22.2539 11.2671L13.4648 20.0562C13.2832 20.2378 13.043 20.3315 12.8027 20.3315C12.5625 20.3315 12.3223 20.2378 12.1406 20.0562L7.74609 15.6616C7.38281 15.2983 7.38281 14.7007 7.74609 14.3374C8.10937 13.9741 8.70703 13.9741 9.07031 14.3374L12.8027 18.0698L20.9297 9.94287C21.293 9.57373 21.8906 9.57373 22.2539 9.94287Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7825_14490"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDot);
export default __webpack_public_path__ + "static/media/checkDot.670a191ce6141cea6549861b83818324.svg";
export { ForwardRef as ReactComponent };